import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { TRuleEditorCommonProps } from '../types';
import type { TQuestionRuleCondition } from 'types/rules.types';
import OperatorCombobox from 'components/comboboxes/OperatorCombobox';

interface Props extends TRuleEditorCommonProps {
  condition: TQuestionRuleCondition;
  onOperatorChange: (operator: string | undefined) => void;
  children: ReactNode;
  // Restricts which operators the question's own type actually supports — e.g. single-select has no
  // meaningful GREATER_THAN/LESS_THAN/BETWEEN. Empty/omitted shows every operator, unrestricted.
  allowedOperators?: string[];
}

const RuleConditionIfAnswer = ({ condition, isReadOnly, onOperatorChange, children, allowedOperators }: Props) => {
  const { t } = useTranslation('Templates');

  return (
    <div className="flex flex-col justify-between gap-2">
      <div className="mx-1 my-2 flex flex-row items-center gap-2">
        <div>{t('question.ruleConditions.ifAnswerLabel')}</div>
        <OperatorCombobox
          disabled={isReadOnly}
          value={condition.operator}
          include={allowedOperators}
          onValueChange={(value) => onOperatorChange((value as string) || undefined)}
        />
      </div>

      <div className="hubert-vertical-center m-1 flex flex-row items-center gap-2">
        <div>{t('question.ruleConditions.answersLabel')}</div>
        <div>{children}</div>
      </div>
    </div>
  );
};

export default RuleConditionIfAnswer;
